import * as v from "valibot";

import { SignIn } from "@/components/sign-in";

const searchSchema = v.object({
  redirect: v.optional(v.string(), "/"),
});

export const Route = createFileRoute({
  component: SignIn,
  validateSearch: searchSchema,
});
